import { Box, IconButton, SvgIcon as MuiSvgIcon } from '@mui/material';
import { FunctionComponent, useState } from 'react';

import Checkbox from '@Components/Checkbox';
import PopOverMenu from '@Components/PopOverMenu';
import Icons from '@Constants/Icons.constants';

import { MenuWithOptionProps } from './MenuWithOptions.types';

const MenuWithOptions: FunctionComponent<MenuWithOptionProps> = (
  props: MenuWithOptionProps
): JSX.Element => {
  const { menuOptions, checkboxProps } = props;
  const { disabled, ...resCheckboxProps } = checkboxProps;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  /**
   * @description - Handles click event on Dropdown-icon and opens/closes popover menu
   */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox disabled={disabled} {...resCheckboxProps} />
        {menuOptions && (
          <IconButton
            disabled={disabled}
            onClick={handleClick}
            sx={{
              padding: 0,
              '&.Mui-disabled': { color: 'action.disabledBackground' },
            }}
            aria-label="menu with options"
          >
            <MuiSvgIcon>{Icons.arrowDropDown}</MuiSvgIcon>
          </IconButton>
        )}
      </Box>
      {menuOptions && (
        <PopOverMenu
          menuItems={menuOptions}
          open={isOpen}
          onClose={handleClose}
          anchorEl={anchorEl}
        />
      )}
    </>
  );
};

MenuWithOptions.defaultProps = {
  checkboxProps: {},
};

export default MenuWithOptions;
